import { Action } from '@ngrx/store';
import { IUserGroups } from '../IUserGroups';
import { IUserEntryDate, IUserEntryDatesResponse } from '../IUserEntryDates';


export enum ActionTypes {
  LoadGroups = '[entrydates] Load Groups',
  LoadUserEntryDates = '[entrydates] Load Entry Dates',
  LoadEntryDatesByGroup = '[entrydates] Load Entry Dates By Group',
  SetEntryDatesByGroup = '[entrydates] Set Entry Dates By Group',
  SetGroups = '[entrydates] Set Groups',
  SetUserEntryDates = '[entrydates] Set Entry Dates',
  UpdateUserEntryDates = '[entrydates] Update Entry Dates',
  UpdateUserEntryDatesSuccess = '[entrydates] Update Entry Dates Success',
  Reset = '[entrydates] Reset'
}

export class Reset implements Action {
  readonly type = ActionTypes.Reset;
}

export class LoadGroups implements Action {
  constructor() {
  }
  readonly type = ActionTypes.LoadGroups;
}

export class LoadEntryDatesByGroup implements Action {
  constructor(public payload: Array<IUserGroups>) { }
  readonly type = ActionTypes.LoadEntryDatesByGroup;
}

export class SetEntryDatesByGroup implements Action {
  constructor(public payload: Array<IUserEntryDate>) {
  }
  readonly type = ActionTypes.SetEntryDatesByGroup;
}

export class SetGroups implements Action {
  constructor(public payload: Array<IUserGroups>) {
  }
  readonly type = ActionTypes.SetGroups;
}

export class LoadUserEntryDates implements Action {
  constructor() {
  }
  readonly type = ActionTypes.LoadUserEntryDates;
}

export class SetUserEntryDates implements Action {
  constructor(public payload: Array<IUserEntryDate>) {
  }
  readonly type = ActionTypes.SetUserEntryDates;
}

export class UpdateUserEntryDates implements Action {
  constructor(public payload: Array<IUserEntryDate>) { }
  readonly type = ActionTypes.UpdateUserEntryDates;
}

export class UpdateUserEntryDatesSuccess implements Action {
  constructor(public payload: IUserEntryDatesResponse) { }
  readonly type = ActionTypes.UpdateUserEntryDatesSuccess;
}

export type ActionsUnion = LoadGroups | SetGroups | LoadUserEntryDates | SetUserEntryDates | UpdateUserEntryDates | UpdateUserEntryDatesSuccess | LoadEntryDatesByGroup | SetEntryDatesByGroup | Reset
  ;
